import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isNull } from 'lodash';
import { ToastrService } from 'ngx-toastr';

import { PoService } from '@app/core/purchase-orders/services/po.service';
import { SettingsService } from '@app/core/settings/services/settings.service';

@Component({
  selector: 'cnc-add-order-items-form',
  templateUrl: './add-order-items-form.component.html',
  styleUrls: ['./add-order-items-form.component.scss'],
})
export class AddOrderItemsFormComponent implements OnInit {
  formData :UntypedFormGroup;

  variantQuotes :any[] = [];
  quotation :any;
  activeRfq :any;
  activeVariantQuote :any = {};

  paymentOption :number = 2;
  paymentOptionText :string = '';

  totalCost :number = 0;
  totalFirst :number = 0;
  unitPrice :number = 0;
  downpaymentPercent :number = 0;
  downpaymentAmount :number = 0;
  isSampleOrder :boolean = false;

  customItem :boolean = false;

  @Input() factoryItems :any;
  @Input() formValue :any;
  @Input() rfq :any;

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    public poService :PoService,
    private toastr :ToastrService,
    public settingsSvc :SettingsService,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      rfq_id: [null],
      logistic: [this.formValue.logistic],
      quantity: [0],
      unit_price: [0],
      source_sku: [''],
    });

    if (this.formValue.order_type == 10) {
      this.isSampleOrder = true;
    }

    if (this.rfq) {
      this.formData.get('rfq_id').patchValue(this.rfq.id);
      this.activeRfq = this.rfq;
      this.showQuotations();
    }
  }

  resetFields() {
    this.formData.get('rfq_id').patchValue(null);
    this.formData.get('quantity').patchValue(0);
    this.formData.get('source_sku').patchValue('');
    this.formData.removeControl('variants');
    this.activeRfq = null;
    this.quotation = null;
    this.activeVariantQuote = null;
    this.totalCost = 0;
    this.totalFirst = 0;
    this.unitPrice = 0;
    this.downpaymentPercent = 0;
    this.downpaymentAmount = 0;
  }

  tryAddItem() {
    if (this.formData.value.quantity > 0) {
      this.computeTotal();
      this.addItem();
    }
  }

  addLineItem(searchTerm) {
    this.customItem = true;
    const rfq :any = {
      id: -1,
      unit_price: 0,
      product_name: searchTerm,
    };
    this.formData.patchValue(rfq);
    this.activeRfq = rfq;
  }

  addItem() {
    const item :any = {
      rfq_id: this.activeRfq.id,
      product_type_id: this.activeRfq.product_type_id,
      internal_sku: this.activeRfq.internal_sku || '-',
      product_name: this.activeRfq.product_name,
      product_description: this.activeRfq.product_description || '-',
      quantity: this.formData.value.quantity,
      source_sku: this.formData.value.source_sku || '',
      unit_price: this.unitPrice,
      line_total: this.totalCost,
      downpayment_percent: this.downpaymentPercent,
      downpayment_amount: this.downpaymentAmount,
      total_first: this.totalFirst,
    };

    item.cbd =
      this.activeRfq.box_width *
      this.activeRfq.box_height *
      this.activeRfq.box_length;
    if (this.activeRfq.cbd == 0) {
      this.activeRfq.cbd =
        this.activeRfq.carton_width *
        this.activeRfq.carton_height *
        this.activeRfq.carton_length;
    }

    if (!this.customItem && this.activeRfq.product_variants?.length > 0) {
      item.variant_json = JSON.stringify(this.formData.value.variants);
      const variantLabels :any[] = [];
      const variantValues :any[] = [];
      Object.keys(this.formData.value.variants).forEach((key) => {
        if (
          this.formData.value.variants[key] &&
          this.formData.value.variants[key].trim().length > 0
        ) {
          variantLabels.push(key);
          variantValues.push(this.formData.value.variants[key]);
          // variants.push({ k: key, v: fd.variants[key] });
          // variantsText.push(fd.variants[key]);
        }
      });
      item.variant_label = variantLabels.join(', ');
      item.variant_value = variantValues.join(', ');
    }

    // this.poService.addItem(item);

    // this.toastr.success("SKU item added to Purchase Order.");
    this.resetFields();

    this.activeModal.close(item);
  }

  setActiveVariantQuote(vq :any) {
    this.activeVariantQuote = vq;

    this.activeVariantQuote.tiered_pricing_json.forEach((tp) => {
      if (!tp?.downpayment_percent) {
        tp.downpayment_percent = 0;
      }
      if (!tp?.finalpayment_percent) {
        tp.finalpayment_percent = 0;
      }
      if (!tp?.markup_percent) {
        tp.markup_percent = 0;
      }
    });

    const rawVariants = {};
    Object.keys(this.formData.value.variants).forEach((key) => {
      rawVariants[key] = '';
    });

    this.formData
      .get('variants')
      .patchValue(Object.assign(rawVariants, vq.variants));

    setTimeout(() => {
      this.computeTotal();
    }, 1);
  }

  showQuotations() {
    this.customItem = false;
    this.formData.removeControl('variants');
    this.formData.get('quantity').patchValue(0);

    this.variantQuotes = [];

    if (!this.formData.value.rfq_id) {
      return;
    }

    // this.activeRfq = this.factoryItems.find(
    // 	(row) => row.id == this.formData.value.rfq_id
    // );

    if (!this.activeRfq) {
      return;
    }

    try {
      this.activeRfq.product_variants = JSON.parse(this.activeRfq.product_variants);
    } catch (e) {}
    // set product variants
    const group :any = {};
    if (this.activeRfq.product_variants) {
      const rfqVariants :any[] = Array.from(this.activeRfq.product_variants);
      rfqVariants.forEach((variant :any) => {
        group[variant.variant_name] = new UntypedFormControl('');
      });
    }
    this.formData.addControl('variants', new UntypedFormGroup(group));

    // setup quotation
    const quotes = this.activeRfq.quotations.filter((row) => row.parent_id == 0);
    quotes.forEach((q :any) => {
      if (q.variant_quote_type != 1) {
        this.variantQuotes.push({
          label: 'Base Price ' + (this.variantQuotes.length + 1).toString(),
          variants: {},
          tiered_pricing_json: JSON.parse(q.tiered_pricing_json),
          sample_price: q.sample_price,
          sample_lead_time_days: q.sample_lead_time_days,
        });
      }
    });
    this.quotation = quotes[0];
    // this.quotation = this.activeRfq.quotations.find(
    // 	(row) => row.parent_id == 0
    // );

    // this.formData.patchValue({ logistic: this.quotation.logistic_1 });
    const sku :string =
      !isNull(this.quotation.source_sku) &&
      this.quotation.source_sku.trim().length > 0 &&
      this.quotation.source_sku.trim() != 'null'
        ? this.quotation.source_sku
        : '';
    this.formData.get('source_sku').patchValue(sku);

    // if (this.quotation.variant_quote_type != 1) {
    //     this.variantQuotes.push({
    //         label: 'Base Price',
    //         variants: {},
    //         tiered_pricing_json: JSON.parse(this.quotation.tiered_pricing_json),
    //         sample_price: this.quotation.sample_price,
    //         sample_lead_time_days: this.quotation.sample_lead_time_days

    //     })
    // }

    this.setVariantQuotes(this.quotation.id);
    this.setActiveVariantQuote(this.variantQuotes[0]);
  }

  setVariantQuotes(quotationId :number) {
    const variantQuotations :any[] = this.activeRfq.quotations.filter(
      (row :any) => row.parent_id == quotationId,
    );

    if (variantQuotations && variantQuotations.length > 0) {
      variantQuotations.forEach((vq) => {
        const variants = JSON.parse(vq.variants);
        const labels :any = [];
        Object.keys(variants).forEach((key) => {
          labels.push(variants[key]);
        });
        this.variantQuotes.push({
          label: labels.join(', '),
          variants: variants,
          sample_price: vq.sample_price,
          sample_lead_time_days: vq.sample_lead_time_days,
          tiered_pricing_json: JSON.parse(vq.tiered_pricing_json),
        });
      });
    }
  }

  getVariantTieredPricing(variants :any, qty :number) {
    Object.keys(variants).forEach((key) => {
      if (variants[key] == '') {
        delete variants[key];
      }
    });
    const variantKeys :any = Object.keys(variants);
    let activeTieredPricing = this.variantQuotes[0].tiered_pricing_json;
    let matchMax = 0;
    this.variantQuotes.forEach((vq) => {
      let vqMatch = 0;
      variantKeys.forEach((key) => {
        if (variants[key] == vq.variants[key]) {
          vqMatch += 1;
        }
      });
      if (vqMatch > matchMax) {
        matchMax = vqMatch;
        activeTieredPricing = vq.tiered_pricing_json;
      }
    });

    if (variantKeys.length == matchMax || this.quotation.variant_quote_type != 1) {
      return activeTieredPricing;
    } else {
      return false;
    }

    // return activeTieredPricing;
  }

  computeTotal() {
    if (this.formData.value.quantity > 0) {
      let priceAmt :any = {};

      if (this.isSampleOrder) {
        priceAmt.price = this.activeVariantQuote.sample_price;
        priceAmt.first_payment = this.activeVariantQuote.sample_price;
        priceAmt.downpayment_percent = 100;
      } else if (this.customItem) {
        priceAmt.price = this.formData.value.unit_price;
        priceAmt.first_payment = priceAmt.price;
        priceAmt.downpayment_percent = 100;
      } else {
        let tieredPricing :any = this.activeVariantQuote.tiered_pricing_json;
        if (this.activeRfq.product_variants?.length > 0) {
          tieredPricing = this.getVariantTieredPricing(
            this.formData.value.variants,
            this.formData.value.quantity,
          );
        }
        priceAmt = this.getQuantityPrice(
          this.formData.value.quantity,
          tieredPricing,
        );
      }

      this.unitPrice = priceAmt.price;

      this.totalCost = this.formData.value.quantity * this.unitPrice;
      this.totalFirst = this.formData.value.quantity * priceAmt.first_payment;
      this.downpaymentPercent = priceAmt.downpayment_percent;
      this.downpaymentAmount = this.totalFirst;
    }
  }

  getQuantityPrice(qty :number, tieredPricing :any) {
    const logistic = this.formData.value.logistic;
    const log_key =
      this.quotation.logistic_1 == logistic ? 'logistic_1' : 'logistic_2';

    const qtys = tieredPricing.filter((row) => {
      return row.quantity <= qty;
    });

    if (qtys.length > 0) {
      const pricing = qtys.reduce(function (prev, current) {
        return prev.quantity > current.quantity ? prev : current;
      });

      let markup_percent = 0; //pricing[log_key + '_markup_percent'];
      let downpayment_percent = pricing[log_key + '_downpayment_percent'];

      if (!downpayment_percent || downpayment_percent == 0) {
        downpayment_percent = 0;
        // downpayment_percent = 100;
      }
      if (!markup_percent || markup_percent == 0) {
        markup_percent = 0;
      }
      const price = parseFloat(pricing[log_key]);
      const priceAmt = price + (price * markup_percent) / 100;

      this.paymentOption = 1;
      this.paymentOptionText = pricing[log_key + '_payment_term'];
      if (downpayment_percent > 0) {
        this.paymentOptionText = downpayment_percent.toString() + '% Downpayment';
      }

      return {
        qprice: price,
        price: priceAmt,
        markup_percent: markup_percent,
        downpayment_percent: downpayment_percent,
        first_payment: (priceAmt * downpayment_percent) / 100,
      };
    } else if (tieredPricing.length > 0) {
      let markup_percent = 0; //tieredPricing[0][log_key + '_markup_percent'];
      let downpayment_percent = tieredPricing[0][log_key + '_downpayment_percent'];

      if (!downpayment_percent || downpayment_percent == 0) {
        downpayment_percent = 0;
        // downpayment_percent = 100;
      }
      if (!markup_percent || markup_percent == 0) {
        markup_percent = 0;
      }

      const price = parseFloat(tieredPricing[0][log_key]);
      const priceAmt = price + (price * markup_percent) / 100;

      this.paymentOption = 1;
      this.paymentOptionText = tieredPricing[0][log_key + '_payment_term'];
      if (downpayment_percent > 0) {
        this.paymentOptionText = downpayment_percent.toString() + '% Downpayment';
      }

      return {
        qprice: price,
        price: priceAmt,
        markup_percent: markup_percent,
        downpayment_percent: downpayment_percent,
        first_payment: (priceAmt * downpayment_percent) / 100,
      };
    }

    return {
      qprice: 0,
      downpayment_percent: 0,
      markup_percent: 0,
      price: 0,
      first_payment: 0,
    };
  }

  get variantExists() :boolean {
    return (
      !this.customItem &&
      this.activeRfq &&
      this.activeRfq?.product_variants?.length > 0 &&
      !this.isSampleOrder
    );
  }
}
